import { FC, useEffect, useState } from 'react'
import { IonButton, IonIcon, IonItem, IonLabel, IonList, IonListHeader, useIonToast } from '@ionic/react'
import { refresh } from 'ionicons/icons'
import { Admin } from '../../../API'
import TbnAvatar from '../../../components/models/TbnAvatar'
import { AdminService } from '../../../components/services/AdminService'
import { TbnResponse } from '../../../components/services/TbnResponse'
import { failure } from '../../../components/util/Toast'

interface AdminListProps {}
const AdminList: FC<AdminListProps> = () => {
  const [items, setItems] = useState<Admin[]>([])
  const [presentToast] = useIonToast()

  const fetchItems = async () => {
    const res: TbnResponse = await AdminService.Instance.list()
    if (res.data) setItems(res.data)
    else if (res.errorMessage) failure(res.errorMessage, presentToast)
  }

  useEffect(() => {
    fetchItems()
  }, []) // eslint-disable-line

  return (
    <IonList>
      <IonListHeader>
        <IonLabel>Admins</IonLabel>
        <IonButton fill='clear' onClick={fetchItems}>
          <IonIcon icon={refresh} />
        </IonButton>
      </IonListHeader>
      {items.map((itm: Admin) => (
        <IonItem key={itm.id}>
          <TbnAvatar avatar={itm.avatar} slot='start' />
          <IonLabel>{itm.name}</IonLabel>
        </IonItem>
      ))}
    </IonList>
  )
}

export default AdminList
